/* tslint:disable:no-default-export */
import { ContrastRatio } from '../components/pages/contrast-ratio/page.js';

export default ContrastRatio;
